import React from "react";
import CommonNavbar from "../CommonLayout/CommonNavbar";
import CommonFooter from "../CommonLayout/CommonFooter";
import { Container } from "react-bootstrap";

const AboutUs = () => {
  return (
    <>
      <CommonNavbar />
      <Container style={{ padding: "30px" }}>
        <h2>About Us</h2>
        <div className="mt-4">
          <p>
            Welcome to Psycho Oncology Appointment Platform.
          </p>
          <p>
            Our mission is to provide a secure and compassionate environment that connects clients with qualified mental health professionals. We strive to simplify the appointment booking process, ensuring that every session is seamlessly scheduled and easily accessible.
          </p>
          <p>
            We are committed to supporting mental health by offering a user-friendly experience, where both clients and counsellors can focus on quality care and meaningful conversations. Our approach is centered on trust, reliability, and empathy, helping to make a positive difference in people’s lives.
          </p>
          <p>
            Thank you for choosing our platform as your partner in mental health and wellness.
          </p>
        </div>
      </Container>
      <CommonFooter />
    </>
  );
};

export default AboutUs;
